import React, { Dispatch, SetStateAction, useContext, useEffect, useState } from 'react'
import { Avatar, Button, Card, Col, Input, List, Row, Select, Space, Switch, Table, Tooltip, Typography } from "antd";
import { Formik } from 'formik';
import { AuthContext } from "../../../utilites/auth";
import { CSUserProfile } from '../../../models/csuser-profile-interface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPerson, faPlus, faUser } from '@fortawesome/pro-regular-svg-icons';
import { useHistory } from 'react-router';
import _ from 'lodash';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

const { Title } = Typography;
const { Option } = Select;

type Props = {
  userList: CSUserProfile[];
}

const UserSelectionCard: React.FC<Props> = ({
  userList,
}) => {
  const { profile } = useContext(AuthContext);
  const history = useHistory();
  const [filteredUserList, setFilteredUserList] = useState<CSUserProfile[]>(userList);
  const [filteredName, setFilteredName] = useState<string | null>(null);
  const [statusFilter, setStatusFilter] = useState<string>("active");
  const [userTypeFilter, setUserTypeFilter] = useState<string | null>(null);
  const [userTypeList, setUserTypeList] = useState<string[]>([]);
  useEffect(() => {
    if(!!userList && userTypeList.length < 3) {
      let roles = userList.map(u => u.roleName);
      setUserTypeList([...new Set(roles)].sort())
    }

    var currentList = _.clone(userList) ?? [];
    switch(statusFilter) {
      case "active":
        currentList = userList?.filter(u => u.isActive);
        break;
      case "disabled":
        currentList = userList?.filter(u => !u.isActive);
        break;
      case "all":
        break;
    }

    if(filteredName != null) {
      currentList = currentList.filter(x => x.name.toLowerCase().includes(filteredName?.toLowerCase()));
    }

    if(userTypeFilter != null) {
      currentList = currentList.filter(x => x.roleName.toLowerCase() == userTypeFilter?.toLowerCase());
    }

    setFilteredUserList(currentList);
  }, [userList, statusFilter, filteredName, userTypeFilter])

  let columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      filterMultiple: false,
      render: (name: string, user: CSUserProfile) => {
          return <Button
          type="link"
          onClick={(e) => {
            e.preventDefault();
            history.push(`manage/edit/${user.userId}`);
          }}
          href={`admin/users/manage/edit/${user.userId}`}
        >
          <Space>
            {user.name}
          </Space>
        </Button>
      },
      sorter: {
          compare: (a: { name: string; }, b: { name: string; }) => a.name.localeCompare(b.name)
      },
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (email: string, user: CSUserProfile) => {
        return email
      },
      sorter: {
        compare: (a: { email: string; }, b: { email: string; }) => a.email.localeCompare(b.email)
      },
    },
    {
      title: 'User Type',
      dataIndex: 'roleName',
      key: 'roleName',
      render: (roleName: string) => {
        return roleName
      },
      sorter: {
        compare: (a: { roleName: string; }, b: { roleName: string; }) => a.roleName.localeCompare(b.roleName)
      },
    },
    {
      title: 'Is Sales User',
      dataIndex: 'isSalesRep',
      key: 'isSalesRep',
      render: (isSalesRep: boolean, user: CSUserProfile) => {
        return isSalesRep ? "Yes" : "No"
      },
      sorter: {
        compare: (a: { isSalesRep: boolean; }, b: { isSalesRep: boolean; }) => { 
          return (a.isSalesRep == b.isSalesRep ? 0 : (a.isSalesRep ? 1 : -1));
        } 
      },
    },
    {
      title: 'Active',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (isActive: boolean) => {
        return isActive ? "Enabled" : "Disabled"
      },
      sorter: {
        compare: (a: { isActive: boolean; }, b: { isActive: boolean; }) => { 
          return (a.isActive == b.isActive ? 0 : (a.isActive ? 1 : -1));
        } 
      },
    }
  ]

  return <Card>
    <Row gutter={[16, 16]}>
      <Col flex={'auto'}>
        <Title level={3}>
          Manage Users
        </Title>
      </Col>
      <Col>
        <Space>
          <Select
            value={statusFilter}
            onChange={(val) => {
              setStatusFilter(val);
            }}
            dropdownMatchSelectWidth={false}
          >
            <Option key="active" value="active">Active Users</Option>
            <Option key="disabled" value="disabled">Disabled Users</Option>
            <Option key="all" value="all">All Users</Option>
          </Select>
          <Select
            value={userTypeFilter}
            onChange={(val) => {
              setUserTypeFilter(val);
            }}
            onClear={() => {
              setUserTypeFilter(null);
            }}
            placeholder={"Filter by User Type"}
            dropdownMatchSelectWidth={false}
            allowClear
          >
            {userTypeList.map((type) => {
              return <Option value={type} key={type}>{type}</Option>
            })}
          </Select>
          <Input
            onChange={(e) => {
              setFilteredName(e?.target?.value ?? null);
            }}
            value={filteredName}
            placeholder={"Filter by Name"}
          />
          <Tooltip title="Create new CS Portal User">
            <Button
              type='primary'
              shape='circle'
              onClick={(e) => {
                e.preventDefault();
                history.push(`manage/create`);
              }}
              href={`admin/users/manage/create`}
            >
              <FontAwesomeIcon icon={faPlus} />
            </Button>
          </Tooltip>
        </Space>
      </Col>
      <Col span={24}>
        <Table
          dataSource={filteredUserList}
          columns={columns}
          size="middle"
          rowKey={(val) => val.id}
        />
      </Col>
    </Row>
  </Card>
}

export default UserSelectionCard;